import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Mail, Linkedin } from "lucide-react";

const LINKEDIN_URL = "https://www.linkedin.com/in/funda-mehmed-bb05653b6";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-white border-t border-slate-200 py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <img
              src="https://customer-assets.emergentagent.com/job_dila-clean/artifacts/p08bjxwq_120d0b4e-e8a5-4be5-9790-b37db7897d9d.jpeg"
              alt="Dila Group BV — Schoonmaak & Services"
              className="h-12 w-auto object-contain"
            />
          </div>
          <p className="mt-4 text-sm text-slate-600 max-w-xs leading-relaxed">
            Professionele schoonmaakdiensten in Antwerpen, voor bedrijven en
            particulieren. 24/7 beschikbaar.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-[#0F172A]">Diensten</h4>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li><Link to="/diensten#huishoudelijk" className="hover:text-[#0284C7]">Huishoudelijke schoonmaak</Link></li>
            <li><Link to="/diensten#kantoor" className="hover:text-[#0284C7]">Kantoorschoonmaak</Link></li>
            <li><Link to="/diensten#diepte" className="hover:text-[#0284C7]">Dieptereiniging</Link></li>
            <li><Link to="/diensten#verhuis" className="hover:text-[#0284C7]">Schoonmaak na verhuis</Link></li>
          </ul>
          <h4 className="mt-6 font-display font-bold text-[#0F172A]">Bedrijf</h4>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li><Link to="/over-ons" className="hover:text-[#0284C7]">Over ons</Link></li>
            <li><Link to="/reviews" className="hover:text-[#0284C7]">Reviews</Link></li>
            <li><Link to="/contact" className="hover:text-[#0284C7]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-[#0F172A]">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-600">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 text-[#16A34A] shrink-0" />
              <span>Brederodestraat 94<br />2018 Antwerpen</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-[#16A34A] shrink-0" />
              <a href="tel:0466324304" className="hover:text-[#0284C7]">0466 32 43 04</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-[#16A34A] shrink-0" />
              <a href="mailto:info@dilagroupservices.be" className="hover:text-[#0284C7] break-all">info@dilagroupservices.be</a>
            </li>
            <li className="flex items-center gap-2">
              <Clock size={16} className="text-[#16A34A] shrink-0" />
              Open 24 uur, 7/7
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-[#0F172A]">Direct contact</h4>
          <p className="mt-4 text-sm text-slate-600">
            Een snelle vraag of dringende klus? Bel ons direct.
          </p>
          <a
            href="tel:0466324304"
            className="mt-5 inline-flex items-center justify-center rounded-full bg-[#0284C7] hover:bg-[#0369A1] text-white font-semibold px-5 py-2.5 shadow-md shadow-sky-200 transition-all hover:-translate-y-0.5"
            data-testid="footer-call-btn"
          >
            <Phone size={16} className="mr-2" /> Bel nu
          </a>

          <div className="mt-6 pt-5 border-t border-slate-200">
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500">Volg ons</p>
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className="mt-3 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-[#0F172A] hover:border-[#0A66C2] hover:text-[#0A66C2] transition-all"
            >
              <span className="inline-flex h-6 w-6 items-center justify-center rounded-md bg-[#0A66C2] text-white">
                <Linkedin size={14} strokeWidth={2.5} />
              </span>
              LinkedIn — Funda Mehmed
            </a>
          </div>
        </div>
      </div>

      <div className="mt-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 border-t border-slate-200 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} Dila Group BV. Alle rechten voorbehouden.</p>
        <p>Schoonmaakbedrijf · BTW BE · 2018 Antwerpen</p>
      </div>
    </footer>
  );
};
